module.exports = __webpack_public_path__ + "img/new_film.d98544fc.svg";